import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getNodesInPath } from '../getNodesInPath/getNodesInPath';
export function getNodeTreeForId(id, relations) {
    const { children } = relations[id];
    return children.reduce((tree, childId) => {
        tree.push(...getNodeTreeForId(childId, relations));
        return tree;
    }, [id]);
}
export function getIsNodeInTreeForId(rootNodeId, targetNodeId, relations) {
    return getNodeTreeForId(rootNodeId, relations).indexOf(targetNodeId) !== -1;
}
export function getNodeTree(relations) {
    return Object.values(relations).reduce((tree, { id, parentId }) => {
        if (parentId !== null) {
            return tree;
        }
        tree[id] = getNodeTreeForId(id, relations);
        return tree;
    }, {});
}
export const getRootTree = (relations) => {
    const initNode = Object.values(relations).find(({ nodeType }) => nodeType.toLowerCase() === FlowNodeTypes.INIT);
    if (!initNode) {
        throw new Error('Could not find init node when generating root tree');
    }
    return getNodesInPath([initNode.id], relations);
};
